import React from 'react';

import { useFirebaseClaims } from 'utils/hooks';

import FloatingTutorialButton from './FloatingTutorialButton';

type Props = {};

const OnboardingTutorial: React.FC<React.PropsWithChildren<Props>> = () => {
  const { claims } = useFirebaseClaims();

  return claims?.showOnboardingTutorial ? <FloatingTutorialButton /> : null;
};

export default OnboardingTutorial;
